import { ComponentProps } from 'react'
import { request } from 'react-common'
import { SvgComponent } from '@platform/ui'

export enum LtiVersion {
  lti11 = 1,
  lti13 = 3,
}

export enum ActivityType {
  text = 1,
  lti = 2,
  composite = 3,
  event = 4,
  video = 5,
  discussion = 6,
}

export enum DisplayMode {
  Fullscreen = 1,
  EmbeddedAuto = 2,
  EmbeddedCustom = 3,
}

export enum ActivityState {
  draft = 1,
  ready = 2,
  expired = 3,
  archived = 4,
}

export enum PresentationMode {
  Tree = 0,
  Tiles = 1,
  LongRead = 2,
  LongReadWithoutActivityNames = 3,
}

export enum ResourceLibraryBuiltinType {
  None = 0,
  VirtualLabs = 1,
  CodingLabs = 2,
  Stem = 3,
  PrivateFiles = 4,
  PublicFiles = 5,
  RichText = 6,
  Composite = 7,
  JupyterLabs = 8,
  Scorm = 9,
  Assessment = 10,
  Classroom = 11,
  Survey = 12,
  ClassDiscussion = 13,
  Assignment = 14,
}

export type ActivityId = string
export interface Activity {
  id: ActivityId
  type: ActivityType
  ltiVersion: LtiVersion | null
  code: string
  name: string
  description: string
  duration: number | null
  recommendedDuration: number | null
  content: string
  contentAvailable: boolean
  editorContent?: string
  imageUrl?: string
  toolUrl: string | null
  toolResourceId: string | null
  state: ActivityState
  supportReview: boolean | null
  supportLtiGrading: boolean | null
  supportLtiAuthoring: boolean | null
  supportMobileView: boolean | null
  supportFullscreenView: boolean | null
  supportCollaborativeMode: boolean | null
  supportPersonalMode: boolean | null
  displayMode: DisplayMode | null
  passingScore: number
  normalizedPassingScore: number
  preferredWidth: number | null
  preferredHeight: number | null
  proctored: boolean | null
  maxScore: number
  presentationMode: PresentationMode
  childrenCount: number
  resourceLibrary: {
    id: string
    name: string
    builtinType: ResourceLibraryBuiltinType
    type: number
    knownType: number
    activityType: string
  }
  settings?: {
    show_submit_button: boolean | null
    show_close_button: boolean | null
  }
}

export class ActivityApi {
  private static readonly api = request('activities/:id?')
  private static readonly proctoringStartToken = request('activities/:id/proctoring-start-token')

  // TODO specify types
  static query(queries: Record<string, any>) {
    return this.api.get({ query: queries }).then((res) => res.body as Activity[])
  }

  static get(id: string) {
    return this.api.get({ url: { id } }).then((res) => res.body as Activity)
  }
}

export const ACTIVITY_ICON_MAP: Record<ActivityType, ComponentProps<typeof SvgComponent>['name']> = {
  [ActivityType.text]: 'RichTextBoldStroke',
  [ActivityType.lti]: 'LtiScormBoldStroke',
  [ActivityType.composite]: 'CompositeBoldStroke',
  [ActivityType.video]: 'VideoBoldStroke',
  [ActivityType.event]: 'QuestionBoldStroke',
  [ActivityType.discussion]: 'SpeechBoldStroke',
}
